export const toggleBulkPricing = () => ({
    type: "TOGGLE_BULKPRICING_OPEN",
  });
  
  export const toggleBulkPricingClose = () => ({
    type: "TOGGLE_BULKPRICING_CLOSE",
  });
  
  